import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import currencySymbols from 'constants/currencies';

const FormattedCurrency = ({ className, currency, amount, hideEmptyDecimals, dataCy, dataTestId }) => (
  <span className={className} data-cy={dataCy} data-testid={dataTestId}>
    {amount < 0 ? '-' : ''}
    {currencySymbols[currency]}
    <FormattedNumber value={Math.abs(amount)} minimumFractionDigits={hideEmptyDecimals ? 0 : 2} maximumFractionDigits={2} />
  </span>
);

FormattedCurrency.propTypes = {
  hideEmptyDecimals: PropTypes.bool,
  className: PropTypes.string,
  currency: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  dataCy: PropTypes.string,
  dataTestId: PropTypes.string
};

export default FormattedCurrency;
